<template>
    <div class="manage-chargebee-account">
        <h3 class="typographies-heading-h3">{{ $l10n.__('Gérer mon abonnement') }}</h3>

        <div
            v-for="action in actions"
            :key="action.section"
            class="manage-chargebee-account__container-btn"
        >
            <CompassPlainButton
                :label="action.labelBtn"
                @click="openCbPortalSection(action.section)"
            />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            actions: [
                {
                    labelBtn: this.$l10n.__('Informations sur le compte'),
                    section: 'ACCOUNT_DETAILS',
                },
                {
                    labelBtn: this.$l10n.__('Adresse de facturation'),
                    section: 'ADDRESS',
                },
                {
                    labelBtn: this.$l10n.__('Méthodes de paiement'),
                    section: 'PAYMENT_SOURCES',
                },
                {
                    labelBtn: this.$l10n.__('Historique de facturation'),
                    section: 'BILLING_HISTORY',
                },
            ],
        };
    },
    beforeDestroy() {
        window.ChargebeeGlobal.clearChargebeeScript();
    },
    methods: {
        async openCbPortalSection(section) {
            await window.ChargebeeGlobal.openCbPortalSection(section);
        },
    },
};
</script>

<style lang="scss" scoped>
.manage-chargebee-account {
    border: 1px solid var(--colors-common-border-default);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: var(--spacing-3);

    h3 {
        border-bottom: 1px solid var(--colors-common-border-lighter);
        margin: 0;
        padding-bottom: var(--spacing-1);
    }

    &__container-btn {
        border-bottom: 1px solid var(--colors-common-border-lighter);
        padding: var(--spacing-1) 0;

        .compass-button {
            width: fit-content;
        }
    }
}
</style>
